<div
    *ngIf="
        authorisations != null && authorisations.length > 0 && visibleFormFields
    "
    style="height: 100%"
>
    <div class="vertical-container contents container-scroll modal-scrollbar">
        <ng-container
            *ngFor="let authorisation of authorisations; let i = index"
        >
            <!-- Conditions -->
            <h4
                class="bottom-buffer"
                *ngIf="authorisation.conditionList.length > 0"
            >
                Authorisation Conditions
            </h4>
            <div>
                <p
                    *ngFor="let condition of authorisation.conditionList"
                    [innerHtml]="condition"
                ></p>
            </div>

            <h4 class="bottom-buffer">Authorisation Details</h4>

            <!-- Messages -->
            <div
                *ngIf="visibleFormFields.includes('messages')"
                class="horizontal-container bottom-buffer"
            >
                <div class="fcol-12">
                    <span class="display-label">Messages</span>
                    <div class="horizontal-container fill">
                        <airspace-authorisation-messaging
                            [messages]="authorisation.messageList"
                        ></airspace-authorisation-messaging>
                    </div>
                </div>
            </div>

            <!-- Errors -->
            <div
                *ngIf="authorisation?.errors != null"
                class="horizontal-container bottom-buffer"
            >
                <div class="fcol-12">
                    <span class="display-label">Authorisation Errors</span>
                    <div class="horizontal-container fill">
                        <show-errors
                            [errors]="authorisation.errors"
                        ></show-errors>
                    </div>
                </div>
            </div>

            <!-- GCD Table header -->
            <div
                *ngIf="authorisation?.activeGridCellList?.length > 0"
                class="horizontal-container bottom-buffer"
            >
                <div class="fcol-12">
                    <span class="display-label">
                        Grid Cell Definition (GCD)
                        <button
                            type="button"
                            class="btn btn-tertiary pull-right"
                            tooltip="{{
                                collapseGcdTable
                                    ? 'Show GCD value table'
                                    : 'Hide GCD value table'
                            }}"
                            placement="top"
                            (click)="toggleGcdTable()"
                        >
                            <span
                                *ngIf="!collapseGcdTable"
                                class="fal fa-chevron-up"
                            ></span>
                            <span
                                *ngIf="collapseGcdTable"
                                class="fal fa-chevron-down"
                            ></span>
                        </button>
                    </span>
                </div>
            </div>

            <!-- GCD Table body -->
            <div
                *ngIf="authorisation?.activeGridCellList?.length > 0"
                class="horizontal-container bottom-buffer"
            >
                <div class="fcol-6">
                    <div
                        style="width: 100%"
                        [collapse]="collapseGcdTable"
                        [isAnimated]="true"
                    >
                        <table style="width: 100%">
                            <thead>
                                <tr>
                                    <th style="width: 70%">Cell ID</th>
                                    <th style="width: 30%">Max Height</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="
                                        let cell of authorisation.activeGridCellList
                                    "
                                    class="data"
                                >
                                    <td style="width: 50%">
                                        {{ cell.cellId }}
                                    </td>
                                    <td style="width: 50%">
                                        <ng-container
                                            *ngIf="cell.ceiling != null"
                                        >
                                            {{ cell.ceiling.value }}&nbsp;
                                            <span
                                                *ngIf="
                                                    !isFeet(cell.ceiling.unit)
                                                "
                                                style="
                                                    text-transform: lowercase;
                                                "
                                                >{{ cell.ceiling.unit }}</span
                                            >
                                            <span
                                                *ngIf="
                                                    isFeet(cell.ceiling.unit)
                                                "
                                                >ft AGL</span
                                            >
                                        </ng-container>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div [collapse]="!collapseGcdTable" [isAnimated]="true">
                        Max Authorised Height:
                        {{ authorisation.maximumHeight }}&nbsp;ft AGL
                    </div>
                </div>
                <div
                    class="fcol-5 airspace-result-container"
                    style="justify-content: center"
                >
                    <div [collapse]="collapseGcdTable" [isAnimated]="true">
                        Max Authorised Height:&nbsp;{{
                            authorisation.maximumHeight
                        }}ft AGL
                        <div
                            *ngIf="authorisation.maximumHeight === 0"
                            class="airspace-result-parameter fail"
                            style="text-transform: capitalize"
                        >
                            GCD does not permit flying
                        </div>
                    </div>
                </div>
            </div>

            <!-- Authorisation heading + action buttons -->
            <div>
                <h4 class="section-heading">
                    <span
                        >Authorisation
                        {{ authorisations.length > 1 ? i + 1 : '' }}</span
                    >
                    <div></div>

                    <!-- Cancel (not in past, not in terminal status) -->
                    <button
                        *ngIf="
                            authorisation.status === 'INVALID' ||
                            (!isInPast &&
                                authorisation.status !== 'CANCELLED' &&
                                authorisation.status !== 'REJECTED' &&
                                authorisation.status !== 'RESCINDED' &&
                                authorisation.status !== 'RESCINDED_AWAITING' &&
                                authorisation.status !== 'COMPLETED')
                        "
                        type="button"
                        class="btn btn-danger btn-xs"
                        [disabled]="working"
                        (click)="cancel.emit(authorisation)"
                    >
                        Cancel
                    </button>

                    <!-- Close (in past, not terminal) -->
                    <button
                        *ngIf="
                            isInPast &&
                            authorisation.status !== 'CANCELLED' &&
                            authorisation.status !== 'REJECTED' &&
                            authorisation.status !== 'RESCINDED' &&
                            authorisation.status !== 'RESCINDED_AWAITING' &&
                            authorisation.status !== 'INVALID' &&
                            authorisation.status !== 'COMPLETED'
                        "
                        type="button"
                        class="btn btn-danger btn-xs"
                        [disabled]="working"
                        (click)="closeAuth.emit(authorisation)"
                    >
                        Close
                    </button>

                    <!-- Delete (LAANC terminal) -->
                    <button
                        *ngIf="
                            airspaceAuthorisationType === 'USA_LAANC' &&
                            (authorisation.status === 'CANCELLED' ||
                                authorisation.status === 'REJECTED' ||
                                authorisation.status === 'RESCINDED' ||
                                authorisation.status === 'COMPLETED')
                        "
                        type="button"
                        class="btn btn-danger btn-xs"
                        [disabled]="working"
                        (click)="delete.emit(authorisation)"
                    >
                        Delete
                    </button>
                </h4>

                <!-- ID -->
                <div class="bottom-buffer">
                    <span class="display-label">ID</span>
                    <div class="horizontal-container fill">
                        {{ authorisation.id }}
                    </div>
                </div>

                <!-- Status -->
                <div class="bottom-buffer">
                    <span class="display-label">Status</span>
                    <div
                        class="horizontal-container fill"
                        [ngClass]="{
                            'space-between':
                                authorisation.status === 'RESCINDED_AWAITING'
                        }"
                    >
                        <div
                            class="authorisation-status"
                            [ngClass]="{
                                'authorisation-pass':
                                    authorisation.status === 'APPROVED' ||
                                    authorisation.status === 'DECLARED',
                                'authorisation-pending':
                                    authorisation.status === 'PENDING',
                                'authorisation-fail':
                                    authorisation.status === 'REJECTED' ||
                                    authorisation.status === 'CANCELLED' ||
                                    authorisation.status === 'RESCINDED' ||
                                    authorisation.status ===
                                        'RESCINDED_AWAITING',
                                'authorisation-closed':
                                    authorisation.status === 'COMPLETED'
                            }"
                        >
                            {{
                                authorisation.status | formatAuthorisationStatus
                            }}
                        </div>

                        <!-- Acknowledge rescinded -->
                        <button
                            *ngIf="
                                authorisation.status === 'RESCINDED_AWAITING'
                            "
                            type="button"
                            class="btn btn-xs btn-pill btn-primary"
                            [disabled]="working"
                            (click)="acknowledgeRescinded.emit(authorisation)"
                        >
                            Acknowledge
                        </button>
                    </div>

                    <!-- LAANC manual pending message -->
                    <div
                        *ngIf="
                            authorisation.status === 'RESCINDED_AWAITING' ||
                            (authorisation.status === 'PENDING' &&
                                authorisation.authorisationEligibility ===
                                    'MANUAL')
                        "
                        class="horizontal-container fill top-buffer"
                    >
                        <div
                            class="alert alert-warning"
                            style="
                                padding: 6px;
                                font-size: larger;
                                line-height: normal;
                            "
                        >
                            <p>
                                This authorization is pending further
                                coordination. This is a manual approval process
                                with commensurate timelines. The FAA's goal is
                                to respond with a decision regarding this
                                authorization within 30 days, but in some cases
                                a decision may take up to 90 days.
                            </p>
                            <br />
                            <p>
                                <strong>Please note:</strong> While this
                                authorization is pending please do not follow up
                                with Air Traffic by phone as this may result in
                                the request being denied by the FAA.
                            </p>
                        </div>
                    </div>

                    <!-- LAANC manual rejected message -->
                    <div
                        *ngIf="
                            airspaceAuthorisationType === 'USA_LAANC' &&
                            authorisation.status === 'REJECTED' &&
                            authorisation.authorisationEligibility === 'MANUAL'
                        "
                        class="horizontal-container fill top-buffer"
                    >
                        <div
                            class="alert alert-warning"
                            style="
                                padding: 6px;
                                font-size: larger;
                                line-height: normal;
                            "
                        >
                            <p>
                                Your request for Further Coordination was denied
                                by the controlling facility. The operation was
                                denied for reasons that may include any of the
                                following: altitude, date, time, or duration of
                                the requested operation. Re-submitting the same
                                request through LAANC will result in a denial.
                            </p>
                            <br />
                            <p>
                                To continue pursuit of an authorization for the
                                operation, consider altering part, or all, of
                                the request and re-submitting either through
                                LAANC or through FAA DroneZone.
                            </p>
                        </div>
                    </div>

                    <!-- Invalid airspace -->
                    <div
                        *ngIf="
                            airspaceAuthorisationType === 'USA_LAANC' &&
                            authorisation.validity === 'INVALID_AIRSPACE' &&
                            getStatusCategory(authorisation.status) ===
                                'PENDING'
                        "
                        class="horizontal-container fill top-buffer"
                    >
                        <div
                            class="alert alert-danger"
                            style="
                                padding: 6px;
                                font-size: larger;
                                line-height: normal;
                            "
                        >
                            <p>
                                This authorization is no longer valid and must
                                be cancelled by you.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Rejection reason -->
                <div
                    *ngIf="authorisation.rejectionReason"
                    class="bottom-buffer"
                >
                    <span class="display-label">Reason</span>
                    <div class="horizontal-container fill">
                        <div>{{ authorisation.rejectionReason }}</div>
                    </div>
                </div>

                <!-- Controlling authority -->
                <div
                    *ngIf="authorisation.controllingAuthority"
                    class="bottom-buffer"
                >
                    <span class="display-label">Controlling Authority</span>
                    <div class="horizontal-container fill">
                        <div>{{ authorisation.controllingAuthority }}</div>
                    </div>
                </div>

                <!-- Times -->
                <div class="bottom-buffer">
                    <span class="display-label">Start Time</span>
                    <div class="horizontal-container fill">
                        <div>
                            {{
                                authorisation.startTime
                                    | formatLocalDateTimeWithUTC
                                        : formValues?.timeZone
                            }}
                        </div>
                    </div>
                </div>
                <div class="bottom-buffer">
                    <span class="display-label">End Time</span>
                    <div class="horizontal-container fill">
                        <div>
                            {{
                                authorisation.endTime
                                    | formatLocalDateTimeWithUTC
                                        : formValues?.timeZone
                            }}
                        </div>
                    </div>
                </div>

                <!-- Authorisation text / conditions -->
                <ng-container *ngIf="authorisation.authorisationText">
                    <span class="display-label">Conditions</span>
                    <div class="horizontal-container fill">
                        <p [innerHTML]="authorisation.authorisationText"></p>
                    </div>
                </ng-container>
            </div>

            <!-- Mission Details sub-section -->
            <h4 class="top-buffer bottom-buffer">Mission Details</h4>

            <div
                *ngIf="
                    visibleFormFields.includes('publicMissionName') &&
                    authorisation?.publicMissionName
                "
                class="bottom-buffer"
            >
                <span class="display-label">Public Mission Name</span>
                <div class="horizontal-container fill">
                    <div>{{ authorisation.publicMissionName }}</div>
                </div>
            </div>

            <div
                *ngIf="
                    formValues?.casaFlightProfile &&
                    visibleFormFields.includes('flightProfile')
                "
                class="bottom-buffer"
            >
                <span class="display-label">Planned Flight Profile</span>
                <div class="horizontal-container fill">
                    <div>{{ flightProfileName }}</div>
                </div>
            </div>

            <div *ngIf="mission?.maximumHeight" class="bottom-buffer">
                <span class="display-label">Planned Max Height</span>
                <div class="horizontal-container fill">
                    <div>{{ mission.maximumHeight }}&nbsp;ft AGL</div>
                </div>
            </div>

            <div class="bottom-buffer">
                <span class="display-label">Start Time</span>
                <div class="horizontal-container fill">
                    <div>
                        {{
                            authorisation.startTime
                                | formatLocalDateTimeWithUTC
                                    : formValues?.timeZone
                        }}
                    </div>
                </div>
            </div>
            <div class="bottom-buffer">
                <span class="display-label">End Time</span>
                <div class="horizontal-container fill">
                    <div>
                        {{
                            authorisation.endTime
                                | formatLocalDateTimeWithUTC
                                    : formValues?.timeZone
                        }}
                    </div>
                </div>
            </div>

            <!-- RPIC -->
            <div class="bottom-buffer">
                <span class="display-label">Remote Pilot</span>
                <div
                    *ngIf="formValues?.rpic != null"
                    class="horizontal-container fill"
                >
                    <span class="right-buffer">
                        {{ formValues.rpic.firstName }}&nbsp;{{
                            formValues.rpic.lastName
                        }}
                    </span>
                    <span class="right-buffer">
                        <label>{{ formValues.rpicAuthLabel }}</label
                        >&nbsp;{{ formValues.rpicArn }}
                    </span>
                    <span class="right-buffer">
                        <label>Ph:</label>&nbsp;{{ formValues.rpicPhone }}
                    </span>
                </div>
            </div>

            <!-- CRP -->
            <div
                *ngIf="visibleFormFields.includes('crp')"
                class="bottom-buffer"
            >
                <span class="display-label">Chief Remote Pilot</span>
                <div *ngIf="formValues?.crp == null">
                    <span>No CRP details available</span>
                </div>
                <div
                    class="horizontal-container"
                    *ngIf="formValues?.crp != null"
                >
                    <span class="right-buffer">
                        {{ formValues.crp.firstName }}&nbsp;{{
                            formValues.crp.lastName
                        }}
                    </span>
                    <span class="right-buffer">
                        <label>{{ formValues.crpAuthLabel }}</label
                        >&nbsp;{{ formValues.crpArn }}
                    </span>
                </div>
            </div>

            <!-- RPA list -->
            <div class="bottom-buffer">
                <span class="display-label">RPA</span>
                <ng-container *ngFor="let rpa of formValues?.rpaList">
                    <div class="horizontal-container">
                        <span class="right-buffer">{{ rpa.nickname }}</span>
                        <span>
                            <label>Serial:</label>&nbsp;{{
                                rpa.manufacturerSerialNumber
                            }}
                        </span>
                    </div>
                </ng-container>
            </div>

            <!-- Delegated authority -->
            <div
                *ngIf="
                    visibleFormFields.includes('delegatedAuthority') &&
                    formValues?.delegatedAuthority
                "
                class="bottom-buffer"
            >
                <span class="display-label">
                    {{
                        formValues.delegatedAuthority?.authorityType
                            ?.abbreviation
                    }}
                </span>
                <div
                    class="vertical-container"
                    *ngIf="formValues.delegatedAuthority != null"
                >
                    <div
                        *ngIf="
                            formValues.delegatedAuthority.authorityType
                                ?.identifierLabel ||
                            formValues.delegatedAuthority.identifier
                        "
                    >
                        {{
                            formValues.delegatedAuthority.authorityType
                                ?.identifierLabel
                                ? formValues.delegatedAuthority.authorityType
                                      ?.identifierLabel
                                : 'Certificate'
                        }}:&nbsp;{{ formValues.delegatedAuthority.identifier }}
                    </div>
                    <div>
                        {{ formValues.delegatedAuthority.authorityType?.name }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
